import { Box, GridItem, IconButton } from '@chakra-ui/react'
import React, { useCallback, useContext, useEffect } from 'react'
import { ChevronLeftIcon } from '@chakra-ui/icons'
import { LayoutContext } from './Layout'
import { leftPanelWidth, rightPanelWidth } from './layout-constants'

const largeSize = 1280 // lg
const extraLargeSize = 1536 // xl
export const LeftPanel = ({ keepOpen, children }) => {
  const { isLeftPanelOpen, onToggleLeftPanel, isRightPanelOpen } =
    useContext(LayoutContext)

  useEffect(() => {
    if (keepOpen && window.innerWidth >= largeSize) {
      onToggleLeftPanel(true)
    } else if (window.innerWidth < largeSize) {
      onToggleLeftPanel(false)
    }
    return () => {
      onToggleLeftPanel(false)
    }
  }, [keepOpen, onToggleLeftPanel])

  const handleWindowResize = useCallback(() => {
    if (
      window.innerWidth >= largeSize &&
      window.innerWidth <= extraLargeSize + rightPanelWidth
    ) {
      onToggleLeftPanel(!isRightPanelOpen)
    } else if (window.innerWidth < largeSize) {
      onToggleLeftPanel(false)
    }
  }, [onToggleLeftPanel, isRightPanelOpen])

  useEffect(() => {
    handleWindowResize()
    window.addEventListener('resize', handleWindowResize)
    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [handleWindowResize])

  return (
    <GridItem
      top={0}
      left={0}
      w={{
        base: isLeftPanelOpen ? '100vw' : 0,
        md: isLeftPanelOpen ? leftPanelWidth : 0,
      }}
      h="100vh"
      position="relative"
      zIndex={99}
      backgroundColor="brand.white"
      className="left-panel"
    >
      <Box>
        <Box
          height="100vh"
          position="fixed"
          left={0}
          top={0}
          w="10px"
          backgroundColor="brand.blue"
          zIndex={2}
          onClick={() =>
            onToggleLeftPanel(currentLeftPanelOpen => !currentLeftPanelOpen)
          }
          display={!isLeftPanelOpen ? 'block' : 'none'}
        />
        <IconButton
          boxShadow="0 2px 4px 0 rgba(0,0,0,0.1)"
          backgroundColor={{
            base: isLeftPanelOpen ? 'white' : 'brand.blue',
            md: 'brand.blue',
          }}
          top="28px"
          right={{
            base: isLeftPanelOpen ? '20px' : '-24px',
            md: isLeftPanelOpen ? '-14px' : '-24px',
          }}
          transform={!isLeftPanelOpen ? 'rotate(180deg)' : 'rotate(0deg)'}
          borderRadius="100%"
          _hover={{
            backgroundColor: {
              base: isLeftPanelOpen ? 'white' : 'brand.blue',
              md: 'brand.blue',
            },
          }}
          _focus={{
            backgroundColor: {
              base: isLeftPanelOpen ? 'white' : 'brand.blue',
              md: 'brand.blue',
            },
          }}
          icon={
            <ChevronLeftIcon
              color={{
                base: !isLeftPanelOpen ? 'white' : 'brand.blue',
                md: 'brand.white',
              }}
              w="28px"
              height="20px"
              transition=".3s transform"
            />
          }
          onClick={() =>
            onToggleLeftPanel(currentLeftPanelOpen => !currentLeftPanelOpen)
          }
          position="absolute"
          aria-label="Close"
          zIndex="2100"
          minWidth="34px"
          width="34px"
          height="34px"
        />
      </Box>
      <Box
        overflow="hidden"
        w="100%"
        h="100%"
      >
        {children}
      </Box>
    </GridItem>
  )
}

LeftPanel.displayName = 'LeftPanel'
